import { render, staticRenderFns } from "./TarifariosTarifasFluviales.vue?vue&type=template&id=937e1d84"
import script from "./TarifariosTarifasFluviales.vue?vue&type=script&lang=js"
export * from "./TarifariosTarifasFluviales.vue?vue&type=script&lang=js"
import style0 from "./TarifariosTarifasFluviales.vue?vue&type=style&index=0&id=937e1d84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports